// Tutorial Videos Constants
// Replace YOUR_VIDEO_ID_X with actual YouTube video IDs
// Example: If YouTube URL is https://www.youtube.com/watch?v=dQw4w9WgXcQ
// Use: https://www.youtube.com/embed/dQw4w9WgXcQ

const TutorialVideos = {
    rivhit: {
        title: 'ריווחית',
        videos: [
            { 
                id: 1, 
                title: 'הדרכה 1 - ריווחית', 
                url: 'https://www.youtube.com/watch?v=gUIlB0jNu-Y',
                description: 'הדרכה בסיסית ליבוא קבצי ריווחית'
            },
           
        ]
    },
    hashavshevet: {
        title: 'חשבשבת',
        videos: [
            { 
                id: 1, 
                title: 'הדרכה 1 - חשבשבת', 
                url: 'https://www.youtube.com/watch?v=2ge1dl_Nsig',
                description: 'הדרכה בסיסית ליבוא קבצי חשבשבת'
            },
         
        ]
    },
    atzmait: {
        title: 'עצמאית',
        videos: [
            { 
                id: 1, 
                title: 'הדרכה 1 - עצמאית', 
                url: 'https://www.youtube.com/watch?v=oe-KDOK2d6M',
                description: 'הדרכה בסיסית ליבוא קבצי עצמאית'
            },
          
        ]
    },
    sumit: {
        title: 'Sumit',
        videos: [
            { 
                id: 1, 
                title: 'הדרכה 1 - Sumit', 
                url: 'https://www.youtube.com/watch?v=74kHi2Y4f0U',
                description: 'הדרכה בסיסית ליבוא קבצי Sumit'
            },
          
        ]
    },
    kodbena: {
        title: 'קוד בינה',
        videos: [
            { 
                id: 1, 
                title: 'הדרכה 1 - קוד בינה', 
                url: 'https://www.youtube.com/watch?v=R41NKF-dM7w',
                description: 'הדרכה בסיסית ליבוא קבצי קוד בינה'
            },
          
        ]
    },
    priority:{
        title: 'Priority',
        videos: [
            { 
                id: 1, 
                title: 'הדרכה 1 - Priority', 
                url: 'https://www.youtube.com/watch?v=rsmGpyedjtk',
                description: 'הדרכה בסיסית ליבוא קבצי Priority'
            },
        ]
    }
};

// Export the tutorial videos constant
export default TutorialVideos;















